module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }